module.exports = __webpack_public_path__ + "assets/img/optimised-system.3cfc7dd0.webp";